import BackgroundColor from "%/dynamic-component-editor/options/background-color";

export default class FormBackgroundColor extends BackgroundColor {
  static userInterfaceComponent = {
    ...BackgroundColor.userInterfaceComponent,
    label: "Form Background Color",
  };
}
